export default {"src":"/_next/static/media/xrp.a4e2bfea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};